import { FilterHandler } from '@btime/react-contexts'
import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { Absolute, Relative } from '../../../packages/kiti/components/helpers/Position'
import { useGetWidget } from './_configs'
import Center from '../../../packages/kiti/components/helpers/Center'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Text from '../../../packages/kiti/components/presentation/Text'

const Preview = ({ widget }) => {
  const { t } = useTranslation('common')
  const config = useGetWidget(widget.data?.type) || {}
  const { Presentation } = config

  if (config.noPreview) {
    return (
      <Panel height={25} justify="center" bgColor="light1">
        <Text align="center" bold color="light5" size="h5">
          {t('widgets.noPreview')}
        </Text>
      </Panel>
    )
  }

  return (
    <FilterHandler
      initialState={{
        filter: { date: [moment().startOf('year').toISOString(), moment().endOf('year').toISOString()] }
      }}
    >
      <Relative width="100%" height="100%">
        <Absolute top={0} right={0} left={0} bottom={0} zIndex={5}>
          <Panel width="100%" height="100%" bgColor="transparent" noBorder />
        </Absolute>
        <Center height="100%">
          <Presentation widget={widget} index={0} width={config.previewWidth || '100%'} preview />
        </Center>
      </Relative>
    </FilterHandler>
  )
}

export default Preview
